import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import Row from '@sdk/components/ui/spacing/Row';

import { PREVIEW_LIST_MODAL_HEIGHT } from '@web/newsfeed/components/UserPreviewListModal/userPreviewListModal.consts';

export const Container = styled(Column)`
  max-height: ${PREVIEW_LIST_MODAL_HEIGHT}px;
  overflow: auto;
`;

export const ItemsContainer = styled(Column)`
  min-height: 0;
`;

export const FooterContainer = styled(Row)`
  justify-content: flex-end;
`;

export const ButtonContainer = styled(Row)`
  flex: 1;
  max-width: 210px;
`;
